<app-list-clients [rowTable]="true"></app-list-clients>

